import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import { useRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

import { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/AtsApprovals/types'

interface Props {
  collapseContentData: CollapseContentData
}

const LeftBlock = ({ collapseContentData }: Props) => {
  const { loading, requisition } = useRequisition(collapseContentData.resourceId)

  if (loading || !requisition) {
    return null
  }

  return (
    <>
      <TextArea
        readonly
        label={i18n.t('dashboard.todo.approvals.ats.note')}
        value={requisition.note || ''}
      />
    </>
  )
}

export default LeftBlock
